import * as graphql from 'generated/graphql';
import HorizontalRule from 'packages/kakapo-ui-kit/components/common/HorizontalRule';

import InboxEvaluationOpenTask from './tasks/InboxEvaluationOpenTask';
import InboxFeedbackRequestPendingTask from './tasks/InboxFeedbackRequestPendingTask';
import InboxMomentStartTask from './tasks/InboxMomentStartTask';

const inboxTaskMap = {
	[graphql.InboxTaskType.EvaluationSubmissionOpen]: InboxEvaluationOpenTask,
	[graphql.InboxTaskType.FeedbackRequestPending]: InboxFeedbackRequestPendingTask,
	[graphql.InboxTaskType.MomentStart]: InboxMomentStartTask,
};

export default function InboxTask(props: { task: graphql.InboxTask; refresh: () => void }) {
	const [markAsSeen] = graphql.useMarkInboxTaskMutation();

	const { task } = props;

	const Component = inboxTaskMap[task.type];

	const onAction = () => {
		markAsSeen({
			variables: {
				input: {
					id: props.task.id,
				},
			},
		});
	};

	return (
		<>
			<Component task={task} onAction={onAction} refresh={props.refresh} />
			<HorizontalRule />
		</>
	);
}
